// TEMPORÁRIO — mock local, remover no desenvolvimento do backend.
import simulados from '@/dados-simulados/analises.json';

import type {
  IndicadoresDeDesempenho,
  MapaInterativo,
  PainelExecutivo,
  RelatoriosAnaliticos,
} from './contrato';

/**
 * A ÚNICA porta de entrada do dado simulado nas telas de Análises.
 *
 * Existe para que a troca por API real seja um arquivo, não quatro: quando os
 * endpoints nascerem, as quatro funções abaixo passam a consultar o servidor e
 * nenhuma tela muda. É também o que cumpre a condição 2 da exceção declarada
 * no CLAUDE.md — nada além daqui importa de `dados-simulados/`.
 *
 * As NOTIFICAÇÕES saíram daqui em 2026-10-03: a central e o sino leem a caixa
 * real de quem está logado (`modulos/notificacoes/dados.ts`,
 * `bff/v1/notificacoes`), e a coleção `notificacoes` saiu de
 * `dados-simulados/analises.json` na mesma PR.
 */

/**
 * Atraso curto antes de responder.
 *
 * Não é enfeite: sem ele o estado "carregando" nunca aparece em tela, e um
 * estado que não se consegue ver é um estado que não se consegue conferir.
 */
const LATENCIA_MS = 250;

/** Nome de cada coleção que este módulo sabe carregar. */
export type ColecaoDeAnalises = 'painel' | 'relatorios' | 'indicadores' | 'mapa';

/**
 * Coleções que devem falhar de propósito, para conferir o estado de erro.
 *
 * Vazio em condição normal. Preencher só ao inspecionar a tela à mão — o teste
 * automatizado força o erro pelo próprio teste, sem tocar aqui.
 */
const FALHAR: ReadonlySet<ColecaoDeAnalises> = new Set<ColecaoDeAnalises>();

async function carregar<T>(colecao: ColecaoDeAnalises, valor: T): Promise<T> {
  await new Promise((resolve) => {
    setTimeout(resolve, LATENCIA_MS);
  });

  if (FALHAR.has(colecao)) {
    // Mensagem técnica: fica no log, nunca na tela. A tela mostra ErrorState.
    throw new Error(`Falha simulada ao carregar a coleção "${colecao}".`);
  }

  return valor;
}

export function carregarPainel(): Promise<PainelExecutivo> {
  return carregar('painel', simulados.painel as PainelExecutivo);
}

export function carregarRelatorios(): Promise<RelatoriosAnaliticos> {
  return carregar('relatorios', simulados.relatorios as RelatoriosAnaliticos);
}

export function carregarIndicadores(): Promise<IndicadoresDeDesempenho> {
  return carregar('indicadores', simulados.indicadores as IndicadoresDeDesempenho);
}

export function carregarMapa(): Promise<MapaInterativo> {
  return carregar('mapa', simulados.mapa as MapaInterativo);
}
